const app={};

app.errorHandler=(error, reject)=>{
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

module.exports =app;